import { Injectable } from '@angular/core';
import {
    Observable,
    of
} from 'rxjs';
import { tap } from 'rxjs/operators';
import { DATIQ_RULE_CONDITION_NOT_FOUND_DEFAULT } from '../models';


@Injectable({
    providedIn: 'root',
})
export class DatiqRulesService {
    constructor() {}

    /**
     * A helper function for debugging when the condition function is not found.
     *
     * @param fnName - condition operator function name not found
     * @param type - the evaluator the condition operator function was not found in
     * @returns observable that emits a boolean and logs a console for debugging
     */
    getNoConditionObservable(
        fnName: string,
        type: string
    ): Observable<boolean> {
        return of(DATIQ_RULE_CONDITION_NOT_FOUND_DEFAULT).pipe(
            tap(() =>
                console.warn(
                    `Condition function, ${fnName}, can't be found. Please add it to this evaluator type: ${type}`
                )
            )
        );
    }

    getNoEvaluator$(type: string): Observable<boolean> {
        return of(DATIQ_RULE_CONDITION_NOT_FOUND_DEFAULT).pipe(
            tap(() =>
                console.warn(
                    `Evaluator is not found for ${type}.`
                )
            )
        );
    }
}
